import { render, staticRenderFns } from "./ProjectExtraInfoSection.vue?vue&type=template&id=4f1a722c&scoped=true&"
import script from "./ProjectExtraInfoSection.vue?vue&type=script&lang=js&"
export * from "./ProjectExtraInfoSection.vue?vue&type=script&lang=js&"
import style0 from "./ProjectExtraInfoSection.vue?vue&type=style&index=0&id=4f1a722c&prod&lang=css&"
import style1 from "./ProjectExtraInfoSection.vue?vue&type=style&index=1&id=4f1a722c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1a722c",
  null
  
)

export default component.exports